import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AmbientGlow from "./AmbientGlow";
import MouseGlow from "./MouseGlow";
import StarField from "./StarField";
import { pageTransition } from "../lib/motion";

export default function Layout({ children, noFooter = false, glow = "split", backdrop = null }) {
  return (
    <div className="grain min-h-screen relative bg-[#090909] overflow-x-hidden">
      {backdrop && (
        <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
          <img src={backdrop} alt="" className="w-full h-full object-cover opacity-[0.10]" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#090909]/90 via-[#090909]/70 to-[#090909]/90" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(77,166,255,0.10),transparent_60%)]" />
        </div>
      )}
      <AmbientGlow variant={glow} />
      <StarField />
      <MouseGlow />
      <Navbar />
      <motion.main
        className="pt-20 relative z-10"
        variants={pageTransition}
        initial="initial"
        animate="animate"
      >
        {children}
      </motion.main>
      {!noFooter && <Footer />}
    </div>
  );
}
